import React, { useState } from "react";
import { Redirect, useHistory } from "react-router";
import { AppState } from "../../src/store";
import { agent } from "../agent";
import { useSelector } from "react-redux";
import PaymentRestartConfirmPage from "../pages/PaymentRestartConfirm";
import { URL_PATHS } from "../routes";
import { myDataActions } from "../store/myData";
import { useDispatch } from "react-redux";
import { smartAlert } from "../lib/confirm-alert";

const PaymentRestartConfirmContainer = () => {
    const [isLoading, setIsLoading] = useState(false);
    const canRestart = useSelector(
        (state: AppState) => !!state.payment.status.paidFinishDate
    );
    const dispatch = useDispatch();
    const history = useHistory();

    async function onPaymentRestart(): Promise<void> {
        setIsLoading(true);
        try {
            await agent.putPaymentRestartPaidMember();
            dispatch(myDataActions.myDataShouldLoadSet(true));
            setIsLoading(false);
            history.replace(URL_PATHS.paymentRestartFinish());
        } catch (e) {
            setIsLoading(false);
            console.error(e);
            await smartAlert("有料会員プラン継続処理に失敗しました。");
        }
    }
    if (!canRestart) {
        return <Redirect to={URL_PATHS.paymentInfo()} />;
    }
    return (
        <PaymentRestartConfirmPage
            onPaymentRestart={onPaymentRestart}
            isLoading={isLoading}
        />
    );
};

export default PaymentRestartConfirmContainer;
